/* RRX Cart Drawer – Drawer, Tracking, Recos (max 3), Quick-View mit THEME-SWATCHES
   - Fängt alle Cart-Trigger ab → eigener Drawer
   - Recos: hartes Limit + Dedupe (Design/Handle)
   - Angesehen: duplikatfrei, neueste zuerst
   - Quick-View: echte Theme-Color-Swatches (Bilddateien) bevorzugt; Hex nur Fallback
   - „Black/White“ etc. erzwingen Vollton → kein Theme-Foto mehr
   - Quick-View ohne Preis + Auge-Button für Vollbild (X zum Schließen)
*/
(() => {
  "use strict";
  /* === RRX – Gratis-Badge + Gesamtrabatt-Chip (Buy X Get Y) v4.6 === */
(function(){
  console.log('[RRX] CartEnhancements v4.6 loaded');

/* Styles */
var SID='rrx-cart-enhance-style';
if(!document.getElementById(SID)){
  var st=document.createElement('style'); st.id=SID;
  st.textContent =
    /* Grundlayout Gratis + „alter Preis“ */
    '.rrx-free-ui{display:inline-flex;gap:.5rem;align-items:center;white-space:nowrap}'+
    '.rrx-free-ui .rrx-old{text-decoration:line-through;opacity:.7}'+
    /* GRATIS-Chip im Stil der Ersparnis, grün & gedreht */
    '.rrx-free-ui .rrx-tag{display:inline-flex;align-items:center;justify-content:center;'+
      'padding:.1rem .5rem;border-radius:9999px;background:#569D6F;color:#fff;font-weight:700;'+
      'line-height:1;white-space:nowrap;transform:rotate(-45deg);transform-origin:center;}'+
    /* Gesamtrabatt-Chip bei der Zwischensumme */
    '.rrx-discount-chip{display:inline-flex;align-items:center;gap:.35rem;padding:.1rem .5rem;border-radius:9999px;'+
      'border:1px solid currentColor;opacity:.8;font-weight:600;white-space:nowrap}'+
    /* Von uns versteckte Knoten (z.B. Doppelpreise in Gratis-Zeilen) */
    '.rrx-price-hidden{display:none !important}'+

    /* >>> SICHTBARKEITS-BOOST NUR IM DRAWER <<< */
    /* Preis-Zahlen in allen gängigen Containern IMMER lesbar: */
    '#rrx-cart-drawer [data-rrx-price],'+
    '#rrx-cart-drawer .rrx-price,'+
    '#rrx-cart-drawer .rrx-price *,'+
    '#rrx-cart-drawer .money,'+
    '#rrx-cart-drawer [data-price],'+
    '#rrx-cart-drawer .cart-item__price,'+
    '#rrx-cart-drawer .cart-item__totals,'+
    '#rrx-cart-drawer .rrx-amount,'+
    '#rrx-cart-drawer .rrx-price-now,'+
    '#rrx-cart-drawer .rrx-price-was,'+
    '#rrx-cart-drawer .rrx-price-was s{'+
      'color: var(--text-color, rgb(26,26,26)) !important;'+
      '-webkit-text-fill-color: currentColor !important;'+
      'opacity: 1 !important; filter: none !important; text-shadow: none !important;'+
    '}'+
    /* auch der Zwischensummen-Rabatt-Chip soll sicher lesbar sein */
    '#rrx-cart-drawer .rrx-discount-chip{color: var(--text-color, rgb(26,26,26)) !important;}';
  document.head.appendChild(st);
}


  /* Money */
  var MONEY_FORMAT = null;
  function fmt(c){ try{ if(window.Shopify&&typeof Shopify.formatMoney==='function') return Shopify.formatMoney(c,MONEY_FORMAT);}catch(e){} return (c/100).toFixed(2)+' €'; }
  function fmtNoZeros(c){ var s=fmt(c); s=s.replace(/([.,])00(?!\d)/,''); s=s.replace(/([.,]\d)0(?!\d)/,'$1'); return s; }

  /* Helpers */
  function getHost(){ return document.getElementById('CartDrawer')||document.querySelector('#rrx-cart-drawer, cart-drawer, .CartDrawer, .drawer--cart,[data-drawer="cart"]'); }
  function rootOf(n){ return (n && n.shadowRoot) ? n.shadowRoot : n; }

  function lineIsFree(it){
    var q=Number(it.quantity||1), uO=Number(it.original_price??it.price??0), uF=Number(it.final_price??it.discounted_price??it.price??0);
    var lO=Number(it.original_line_price ?? uO*q), lF=Number(it.final_line_price ?? uF*q);
    if(isNaN(lF)) lF=uF*q;
    if(Array.isArray(it.discounts)&&it.discounts.length){ var d=it.discounts.reduce((s,x)=>s+Number(x.amount||0),0); lF=Math.max(0,lO-d); }
    return lF===0;
  }

  function keyFromRow(row){
    var r=rootOf(row);
    var k=row.getAttribute('data-key')||row.dataset.key||r.querySelector('[data-key]')?.getAttribute?.('data-key');
    if(k) return k;
    var inp=r.querySelector('input[name^="updates["]'); 
    if(inp && inp.name){ var m=inp.name.match(/\[(.+?)\]/); if(m) return m[1]; }
    return null;
  }

  function findLineRows(host){
    var r=rootOf(host);
    var scope = r.querySelector('[data-cart-items], .cart-items, .rrx-cart-list, .Drawer__CartItems, .CartDrawer__Items, .cart-drawer__items') || r;
    return Array.from(scope.querySelectorAll('[data-cart-item],[data-line],[data-key],.cart-item,.rrx-line,.rrx-cart-line'))
      .filter(function(el){ return !el.closest('.cart-recommendations,[data-recommendations],.rrx-recos,.rrx-cross-sell,.rrx-upsell'); });
  }

  /* Preis-Knoten erkennen/ausblenden, damit NUR 1 Preis bleibt */
  var PRICE_SEL = [
    '.rrx-price-current','.price-item--regular','.price-item','.money',
    '[data-price]','.cart-item__price','.cart-item__totals',
    '.rrx-amount','.rrx-item-price','.line-item__price',
    '.product-option__price','.rrx-chip--price'
  ].join(',');
  var TEXT_PRICE_RE = /(?:^|\s)[0-9]+(?:[.,]\d{1,2})?\s*€/;

  function hideOtherPrices(row, ui){
    var r = rootOf(row);
    r.querySelectorAll(PRICE_SEL).forEach(function(el){
      if (ui.contains(el) || el.closest('.rrx-free-ui')) return;
      el.classList.add('rrx-price-hidden');
    });
    Array.from(r.querySelectorAll('span,div,strong,b,small,ins,em')).forEach(function(el){
      if (ui.contains(el) || el.closest('.rrx-free-ui')) return;
      var t=(el.textContent||'').trim(); if (TEXT_PRICE_RE.test(t)) el.classList.add('rrx-price-hidden');
    });
  }
  function showPreviouslyHidden(row){
    var r = rootOf(row);
    r.querySelectorAll('.rrx-price-hidden').forEach(function(el){ el.classList.remove('rrx-price-hidden'); });
    r.querySelectorAll('.rrx-free-ui').forEach(function(n){ n.remove(); });
  }

  /* Gratis-Badge: „Gratis“ (Chip, -45°) + EIN alter Preis */
  function applyFreeBadges(cart){
    var host=getHost(); if(!host||!cart||!Array.isArray(cart.items)) return;
    var rows=findLineRows(host); if(!rows.length) return;
    var map=new Map(cart.items.map(it=>[it.key,it]));

    rows.forEach(function(row){
      var r=rootOf(row), key=keyFromRow(row), item= key && map.get(key);
      if(!item) return;
      var free=lineIsFree(item);

      if(!free && row.__rrxFreeApplied){ row.__rrxFreeApplied=false; showPreviouslyHidden(row); return; }
      if(!free || row.__rrxFreeApplied) return;

      var priceWrap=r.querySelector('.rrx-line-price,.cart-item__price,.rrx-price,.price,[data-price],.cart-item__totals,.rrx-amount,.rrx-item-price') || r;

      var ui=document.createElement('span'); ui.className='rrx-free-ui';
      var tag=document.createElement('span'); tag.className='rrx-tag'; tag.textContent='Gratis';
      var old=document.createElement('span'); old.className='rrx-old';
      old.textContent=fmtNoZeros(Number(item.original_price??item.price??0));
      ui.append(tag,old);

      if(priceWrap.firstChild) priceWrap.insertBefore(ui, priceWrap.firstChild); else priceWrap.appendChild(ui);
      hideOtherPrices(row, ui);

      row.__rrxFreeApplied=true;
    });
  }
/* RRX – Gratis-Text immer weiß */
(function(){
  var ID='rrx-free-tag-white';
  if (document.getElementById(ID)) return;
  var s=document.createElement('style'); s.id=ID;
  s.textContent =
    '#rrx-cart-drawer .rrx-free-ui .rrx-tag{' +
      'color: rgb(255,255,255) !important;' +           /* Text weiß */
      '-webkit-text-fill-color: rgb(255,255,255) !important;' +
    '}';
  document.head.appendChild(s);
})();

  /* Gesamtrabatt-Chip */
  function applySubtotalDiscount(cart){
    var host=getHost(); if(!host||!cart) return;
    var discount=0;
    if(typeof cart.original_total_price==='number'&&typeof cart.total_price==='number') discount=Math.max(0,cart.original_total_price-cart.total_price);
    if(!discount && typeof cart.total_discount==='number') discount=Math.max(discount,cart.total_discount);
    if(!discount && Array.isArray(cart.items)){
      discount=cart.items.reduce(function(s,it){
        var q=Number(it.quantity||1), o=Number(it.original_price??it.price??0)*q, f=Number(it.final_price??it.discounted_price??it.price??0)*q;
        if(Array.isArray(it.discounts)&&it.discounts.length){ var d=it.discounts.reduce((a,x)=>a+Number(x.amount||0),0); f=Math.max(0,o-d); }
        return s+Math.max(0,o-f);
      },0);
    }

    var r=rootOf(host);
    var explicit = r.querySelector('[data-rrx-savings]');
    if(explicit){ explicit.hidden=!(discount>0); if(discount>0) explicit.textContent='− '+fmtNoZeros(discount); return; }

    var subtotalEl  = r.querySelector('[data-rrx-subtotal]');
    var subtotalRow = subtotalEl 
      ? (subtotalEl.closest('.rrx-subtotal-row, .rrx-total-row, .cart__row, .totals, .cart-summary__row') || subtotalEl.parentElement)
      : (r.querySelector('.rrx-subtotal-row, cart-subtotal, [data-subtotal], .totals__subtotal, .cart__row--subtotal, .cart-summary__subtotal')
         || Array.from(r.querySelectorAll('*')).find(function(el){ return (el.textContent||'').toLowerCase().replace(/\s+/g,' ').includes('zwischensumme'); }));
    if(!subtotalRow) return;

    var chip=subtotalRow.querySelector('.rrx-discount-chip');
    if(!(discount>0)){ if(chip) chip.remove(); return; }
    if(!chip){ chip=document.createElement('span'); chip.className='rrx-discount-chip'; (subtotalRow.firstElementChild||subtotalRow).appendChild(chip); }
    chip.textContent='– '+fmtNoZeros(discount);
  }

  /* Orchestrierung */
  function applyAll(c){ try{ applyFreeBadges(c); applySubtotalDiscount(c); }catch(e){ console.warn('[RRX] applyAll',e); } }

  /* Hook + Events + Fallback */
  try{ Object.defineProperty(window,'LAST_CART',{ configurable:true,
    set:function(v){ window.__rrx_lastCart=v; applyAll(v); },
    get:function(){ return window.__rrx_lastCart||null; }
  }); }catch(_){}

  ;['cart:updated','cart:change','product:added','ajaxProduct:added','theme:cart:change','theme:cart:updated']
    .forEach(function(evt){ document.addEventListener(evt,function(e){ var c=(e&&e.detail&&e.detail.cart)||window.__rrx_lastCart||window.LAST_CART||null; if(c){ window.__rrx_lastCart=c; applyAll(c); } }); });

  function fetchCartOnce(){ try{ fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.ok?r.json():null).then(c=>{ if(c){ window.__rrx_lastCart=c; applyAll(c); } }); }catch(e){} }
  document.addEventListener('DOMContentLoaded', fetchCartOnce);
  document.addEventListener('theme:drawer:open', fetchCartOnce);

  var host=getHost(); if(host){
    var timer=null; new MutationObserver(function(){
      if(timer) cancelAnimationFrame(timer);
      timer=requestAnimationFrame(function(){ var c=window.__rrx_lastCart||window.LAST_CART; if(c) applyAll(c); });
    }).observe(rootOf(host), {subtree:true,childList:true});
  }

  window.RRX_forceCartUI=function(){ var c=window.__rrx_lastCart||window.LAST_CART; if(c) applyAll(c); };
})();

  const META_PIXEL_BRIDGE_ENABLED = false; // Shopify-FB-App trackt bereits – Doppelhits vermeiden
  if (window.__RRX_CART_INIT__) return;
  window.__RRX_CART_INIT__ = true;

  const $  = (s) => document.querySelector(s);
  const $$ = (s) => Array.from(document.querySelectorAll(s));
 const drawer = $("#rrx-cart-drawer");
if (!drawer) return;

// Overlay sicherstellen (auto anlegen, falls im DOM nicht vorhanden)
let overlay = $("#rrx-cart-overlay");
if (!overlay) {
  overlay = document.createElement("div");
  overlay.id = "rrx-cart-overlay";
  overlay.hidden = true;
  document.body.appendChild(overlay);
}

  const IN_EDITOR = !!(window.Shopify && Shopify.designMode);
  const MF        = typeof Shopify !== "undefined" ? (null) : "";
  const CURRENCY  = "";

  const THRESHOLD = +(drawer.dataset.threshold || 0); // cents
  const COUNTRY   = (drawer.dataset.country || "").toUpperCase();
  const VAT_MAP   = parseJSON(drawer.dataset.vatMap || "{}", {});
  const VAT       = (VAT_MAP[COUNTRY] ?? VAT_MAP.DEFAULT ?? 19);

  const FREEBAR_SUFFIX  = drawer.dataset.freebarSuffix || "";
  const FREEBAR_REACHED = drawer.dataset.freebarReached || "";

  const RECO_MAX  = 3;
  const QV_ENABLE = ((drawer.dataset.quick ?? "true") === "true");
  const QV_FB     = ((drawer.dataset.shareFb ?? "true") === "true");
  const QV_PIN    = ((drawer.dataset.sharePin ?? drawer.dataset.sharePinterest ?? "true") === "true");
  const QV_WA     = ((drawer.dataset.shareWa ?? drawer.dataset.shareWhatsapp ?? "true") === "true");
  const QV_MAIL   = ((drawer.dataset.shareMail ?? drawer.dataset.shareEmail ?? "true") === "true");


/* === RRX Analytics Bridge (ATC) =================================
   Feuert "added_to_cart" für Shopify Pixels (publish) & Trekkie.
   De-Dupe verhindert Doppel-Events bei Apps/Theme.
==================================================================*/
(function RRX_ATC_BRIDGE() {
  if (window.__RRX_ATC_BRIDGE__) return;         // nur 1x aktivieren
  window.__RRX_ATC_BRIDGE__ = true;

  // --- 1) Kern: ATC einmal feuern --------------------------------
  var lastTs = 0;
  function fireATCOnce(details){
    var now = Date.now();
    if (now - lastTs < 400) return;              // Debounce 0,4s
    lastTs = now;

    try {
      // Web Pixels / Analytics Bus
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var vid = details?.id || details?.variant_id || details?.variantID || details?.variantId || details?.items?.[0]?.variant_id;
        var qty = Number(details?.quantity || details?.qty || details?.items?.[0]?.quantity || 1) || 1;
        Shopify.analytics.publish('product_added_to_cart', {
          products: [{ product_variant_id: vid, quantity: qty }]
        });
      }
      // Klassisches Trekkie
      var trekkie = (window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.trekkie) || window.trekkie;
      if (trekkie && typeof trekkie.track === 'function') {
        var props = {};
        var v = details?.id || details?.variant_id || details?.variantID || details?.variantId || details?.items?.[0]?.variant_id;
        var q = Number(details?.quantity || details?.qty || details?.items?.[0]?.quantity || 1) || 1;
        if (v) props.productVariantId = v;
        props.quantity = q;
        trekkie.track('added_to_cart', props);
      }
    } catch(e){}
  }
  window.RRXFireATCOnce = fireATCOnce;           // optional manuell nutzbar

  /* --- XHR-Bridge: /cart/add(.js) (einmalig) --------------------- */
(function RRX_XHR_BRIDGE(){
  if (window.__RRX_XHR_BRIDGE__) return; 
  window.__RRX_XHR_BRIDGE__ = true;
  var XHR = window.XMLHttpRequest;
  if (!XHR) return;

  var open = XHR.prototype.open, send = XHR.prototype.send;

  XHR.prototype.open = function(method, url){
    this.__rrx_is_add__ = false;
    try {
      var m = String(method||'GET').toUpperCase();
      var u = typeof url === 'string' ? url : (url && url.toString ? url.toString() : '');
      this.__rrx_is_add__ = (m !== 'GET') && (/\/cart\/add(?:\.js)?(?:[?#]|$)/i.test(u));
    } catch(e){}
    return open.apply(this, arguments);
  };

  XHR.prototype.send = function(body){
    try {
      if (this.__rrx_is_add__) {
        // Variant & qty best-effort aus Body extrahieren (falls nötig)
        var variantId=null, qty=1;
        try{
          if (body && typeof body === 'string'){
            var q=new URLSearchParams(body);
            variantId = q.get('id')||q.get('variant')||q.get('variant_id');
            qty = Number(q.get('quantity')||1) || 1;
          }
        }catch(e){}
        // Bridge-Event (Shopify Pixels + Trekkie)
        try{ Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('product_added_to_cart', {products:[{product_variant_id:variantId, quantity:qty}]}); }catch(e){}
        try{
          var tk = (window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.trekkie) || window.trekkie;
          tk && tk.track && tk.track('added_to_cart', {productVariantId:variantId, quantity:qty});
        }catch(e){}
      }
    } catch(e){}
    return send.apply(this, arguments);
  };
})();





  // --- 4) Form-POSTs: /cart/add (ohne .js) -----------------------
  document.addEventListener('submit', function(ev){
    try {
      var form = ev.target;
      if (!form || !form.action) return;
      if (!/\/cart\/add(?!\.js)/.test(form.action)) return; // nur /cart/add ohne .js
      var fd = new FormData(form);
      var vid = fd.get('id') || fd.get('variant') || fd.get('variant_id');
      var qty = Number(fd.get('quantity') || 1) || 1;
      fireATCOnce({ id: vid, quantity: qty });
    } catch(e){}
  }, true); // capture: feuert vor Navigation

  // --- 5) auf gängige Theme/App-Events reagieren -----------------
  window.addEventListener('product:added',     e => fireATCOnce(e.detail || {}));
  window.addEventListener('ajaxProduct:added', e => fireATCOnce(e.detail || {}));
})();



  /* === Meta Pixel Bridge (safe / optional) ===================== */
const MPX = (() => {
  const has = () => typeof window.fbq === "function";
  const id  = () => "rrx_" + Date.now().toString(36) + Math.random().toString(36).slice(2,8);
  const track = (name, payload={}) => {
    if (!has()) return; // Pixel nicht eingebunden → still
    try { fbq("track", name, payload, { eventID: payload.eventID || id() }); } catch(_){}
  };
  const toContents = (items=[]) =>
    items.map(x => ({ id: String(x.item_id || x.id || x.variant_id || x.product_id), quantity: Number(x.quantity||1) }));
  return { track, id, toContents };
  })();

  function moneyFmt(cents){ try { return Shopify.formatMoney(cents, MF); } catch(_){ return (cents/100).toFixed(2).replace(".",",")+"\u00A0€"; } }
  function toCents(v){
  if (v == null) return 0;
  if (typeof v === "number") {
    // Wenn v z.B. 2995 ist (Cents) → lassen; wenn 29.95 (EUR) → *100
    return (v < 50 && v % 1 !== 0) ? Math.round(v * 100) : Math.round(v);
  }
  const s = String(v).replace(",", ".").trim();
  if (!s) return 0;
  return s.includes(".") ? Math.round(parseFloat(s) * 100) : Math.round(parseInt(s, 10) || 0);
  }

  // === Express-Buttons sicher initialisieren (Shopify) ===

  function initExpressButtonsSafely(){
  try {
    if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === "function") {
      Shopify.PaymentButton.init();
    }
  } catch(_) {}
}
function fixExpressVisibility(){
  const btnWrap = drawer.querySelector('.rrx-express .shopify-payment-button');
  if (!btnWrap) return;
  const hasAccelerated = !!btnWrap.querySelector('.shopify-payment-button__button');
  const more = btnWrap.querySelector('.shopify-payment-button__more-options');
  if (more) more.style.display = hasAccelerated ? 'none' : '';
}

// Beobachter für nachträgliches Shopify-Rendering der Express-Buttons (einmalig)
let __rrxExpObserver = null;
function ensureExpressObserver(){
  if (__rrxExpObserver) return; // schon aktiv
  const exp = drawer.querySelector('.rrx-express');
  if (!exp) return;
  __rrxExpObserver = new MutationObserver(() => {
    initExpressButtonsSafely();
    fixExpressVisibility();
  });
  __rrxExpObserver.observe(exp, { childList: true, subtree: true });
}

  function parseJSON(s, fb={}){ try{ return JSON.parse(s); } catch(_){ return fb; } }
  function imgUrl(u, w){
  if (!u) return "";
  // akzeptiere auch Bild-Objekte
  const src = (typeof u === "string")
    ? u
    : (u.url || u.src || u.original_src || (u.image && (u.image.src || u.image.url)) || "");

  if (!src) return "";
  try {
    const url = new URL(src, location.origin);
    if (w) url.searchParams.set("width", String(w));
    return url.toString();
  } catch(_) {
    const s = String(src);
    if (!w) return s;
    const sep = s.includes("?") ? "&" : "?";
    return s + sep + "width=" + w;
  }
}

  function byId(id){ return document.getElementById(id); }
  function dl(event, params={}){ window.dataLayer = window.dataLayer || []; window.dataLayer.push({event, ...params}); }
  function extractHandleFromUrl(u){ const m=String(u||"").match(/\/products\/([^\/?#]+)/); return m ? m[1] : ""; }
  const handleize = (s)=> String(s||"")
    .trim().toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g,"")
    .replace(/[^a-z0-9]+/g,"-")
    .replace(/(^-|-$)/g,"");
  const titleizeHandle = (h)=> h.split("-").map(w=>w? w[0].toUpperCase()+w.slice(1) : w).join("-");

  const cdnFile = (name)=> name.startsWith("http") || name.startsWith("/") ? name : `/cdn/shop/files/${encodeURIComponent(name)}`;

  let LAST_CART = null;

/* Open/Close */
function openDrawer(){
  drawer.setAttribute("aria-hidden","false");
  overlay.hidden = false;
  document.documentElement.classList.add("rrx-cart-open");

  // Express-Buttons beim Öffnen initialisieren + Visibility fixen
  initExpressButtonsSafely();
  requestAnimationFrame(() => {
    initExpressButtonsSafely();
    fixExpressVisibility();
  });
}

function closeDrawer(){
  drawer.setAttribute("aria-hidden","true");
  overlay.hidden = true;
  document.documentElement.classList.remove("rrx-cart-open");
  dl("rrx_cart_drawer_close");
}

window.RRXCartDrawer = { open: openDrawer, close: closeDrawer, refresh };



  overlay.addEventListener("click", closeDrawer);
  drawer.querySelector(".rrx-close")?.addEventListener("click", closeDrawer);

  // ESC: erst Zoom, dann QV, dann Drawer
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const z = byId("rrx-qv-zoom");
    if (z && z.getAttribute("aria-hidden")==="false"){ closeZoom(); return; }
    const qv = byId("rrx-qv");
    if (qv && qv.getAttribute("aria-hidden")==="false"){ closeQuickView(); return; }
    closeDrawer();
  });

  $("#rrx-hidden-cart-opener")?.addEventListener("click", (e) => { e.preventDefault(); openDrawer(); refresh(true); });

  /* Tabs */
  const tabs  = drawer.querySelectorAll("[data-tab]");
  const views = Array.from(drawer.querySelectorAll(".rrx-view"));
  const VALID = new Set(views.map(v => (v.dataset.view||"").toLowerCase()));
  const ALIAS = { overview:"cart","übersicht":"cart",uebersicht:"cart",items:"cart",cart:"cart",recent:"recent",angesehen:"recent" };
  const norm  = (n)=>{ const k=(n||"").toLowerCase(); const m=ALIAS[k]||k; return VALID.has(m) ? m : (views[0]?.dataset.view||""); };
  function showView(which){
    const t = norm(which);
    views.forEach(v => v.hidden = ((v.dataset.view||"").toLowerCase() !== t));
    tabs.forEach(b => b.classList.toggle("rrx-tab--active", norm(b.dataset.tab)===t));
    dl("rrx_tab_switch",{tab:t});
    if (t==="recent") renderRecent();
  }
  tabs.forEach(btn => btn.addEventListener("click",(e)=>{ e.preventDefault(); showView(btn.dataset.tab); }));
  if (location.hash) showView(location.hash.slice(1));
  else showView(views.find(v=>!v.hidden)?.dataset.view || views[0]?.dataset.view);

  /* Theme Drawer kill */
(function injectKillCss(){
  const KILL_SELECTORS = [
'#cart-drawer', '.cart-drawer', '.drawer--cart', '.CartDrawer', '.cart__drawer',
  '.MiniCart', '.mini-cart', '.js-mini-cart',
  '.drawer[data-drawer-id="cart"]', '.drawer[data-drawer="cart"]',
  '#CartDrawer', '.header__icon--cart + .drawer',
  'cart-notification', 'cart-notification-drawer', '#CartNotification',
  '.cart-notification', '#cart-notification'
  ];
  let style = document.getElementById('rrx-kill-theme-cart-css');
  if (!style){ style = document.createElement('style'); style.id='rrx-kill-theme-cart-css'; document.head.appendChild(style); }
  style.textContent = `${KILL_SELECTORS.join(',')} { display: none !important; }`;
})();


  /* Hide scrollbars for reco carousel */
  (function injectCarouselScrollbarCss(){
    if (document.getElementById("rrx-carousel-hide-scrollbar")) return;
    const st=document.createElement("style"); st.id="rrx-carousel-hide-scrollbar";
    st.textContent = `
      #rrx-cart-drawer [data-rrx-reco][data-carousel="1"]{ -ms-overflow-style:none; scrollbar-width:none; }
      #rrx-cart-drawer [data-rrx-reco][data-carousel="1"]::-webkit-scrollbar{ display:none; width:0; height:0; background:transparent; }
    `;
    
    document.head.appendChild(st);
  })();

  /* Intercept theme triggers */
  const TRIGGERS_SEL = [
  '[aria-controls="cart-drawer"]',
  '[aria-controls="CartDrawer"]',          // <- neu
  '[data-drawer="cart"]','[data-cart-open]','#cart-icon-bubble',
  '.header__icon--cart','.header__cart','.cart-toggle','a[href="/cart"]','a[href^="/cart"]',
  'a[href="#cart"]','.js-drawer-open-cart','.open-cart','button[name="cart"]',
  '[data-action="open-drawer"][data-drawer-id="cart"]'
].join(',');
  function shouldIntercept(e){
    const t = e.target;
    if (!t || !t.closest) return false;
    if (t.closest("#rrx-cart-drawer")) return false; // nichts im Drawer selbst abfangen
    return !!t.closest(TRIGGERS_SEL);
  }
  function intercept(e){
    if (!shouldIntercept(e)) return;
    e.preventDefault(); e.stopPropagation(); try{ e.stopImmediatePropagation(); }catch(_){}
    openDrawer(); refresh(true); dl("rrx_cart_trigger_intercepted",{source:"any"});
  }
  if (!IN_EDITOR){ ['click','mousedown','mouseup','touchstart','touchend','keydown'].forEach(evt=>{ document.addEventListener(evt, intercept, {capture:true}); }); }
/* Route Toast-CTAs (Dawn/Impact) in den RRX-Drawer statt /cart */
/* Route Impact-Toast-CTAs in den RRX-Drawer (Shadow-DOM safe) */
(function routeToastCtasToDrawer(){
  const TOAST_HOST_SEL = 'cart-notification, cart-notification-drawer, #CartNotification, .cart-notification';

  function isToastHost(el){
    return !!(el?.matches && el.matches(TOAST_HOST_SEL));
  }
  function hasRRX(){
    return !!(window.RRXCartDrawer && typeof window.RRXCartDrawer.open === 'function');
  }

  function handle(e){
    if (!hasRRX()) return; // wenn unser Drawer nicht geladen ist -> nichts kapern

    const path = (typeof e.composedPath === 'function') ? e.composedPath() : [];
    let inToast = false, hit = null, host = null;

    for (const node of path){
      if (!node || node.nodeType !== 1) continue;
      if (!inToast && isToastHost(node)) { inToast = true; host = node; }
      // Links/Buttons, die zu /cart führen oder Checkout im Toast auslösen
      if (!hit && node.matches?.('a[href*="/cart"], [name="checkout"], .cart-notification__checkout')) {
        hit = node;
      }
    }
    if (!inToast || !hit) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    // Toast ausblenden
    if (host) host.style.display = 'none';

    // Unser Drawer öffnen + aktualisieren
    try{
      window.RRXCartDrawer.open();
      window.RRXCartDrawer.refresh(true);
    }catch(_){}
  }

  // Klicks UND Formular-Submit im Toast abfangen
  document.addEventListener('click', handle, true);   // capture, damit wir vor dem Theme drankommen
  document.addEventListener('submit', (e)=>{
    const path = e.composedPath ? e.composedPath() : [];
    if (path.some(n => n?.matches?.(TOAST_HOST_SEL))) handle(e);
  }, true);
})();

/* Verhindere Redirect zu /cart: fange Produkt-Formulare ab und add-e via AJAX */
(function interceptAddToCartForms(){
  document.addEventListener('submit', function(e){
    const form = e.target && e.target.closest ? e.target.closest('form') : null;
    if (!form) return;

    // Nur echte Add-to-Cart-Forms
    const isAddForm = /\/cart\/add(\.js)?/i.test(form.action || '') || form.querySelector('[name="add"]');
    if (!isAddForm) return;

    // Nichts im eigenen Drawer/QV kaputt machen
    if (form.closest('#rrx-cart-drawer') || form.closest('#rrx-qv')) return;

    // Wenn ein anderes Script bereits per JS handled → nicht doppeln
    if (e.defaultPrevented) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    const fd = new FormData(form);
// Shopify-Bus/trekkie einmal feuern (für Web Pixels)
try {
  const vid = fd.get('id') || fd.get('variant') || fd.get('variant_id');
  const qty = Number(fd.get('quantity') || 1) || 1;
  window.RRXFireATCOnce?.({ id: vid, quantity: qty });
} catch (_) {}

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd
    }).catch(()=>{}).finally(()=> {
      // Drawer öffnen + refreshen
      window.RRXCartDrawer?.refresh?.(false);
      window.RRXCartDrawer?.open?.();
    });
  }, true);
})();


  /* Cart API */
  async function getCart(){ try { return await fetch("/cart.js",{credentials:"same-origin"}).then(r=>r.json()); } catch(_){ return {items:[], item_count:0, total_price:0}; } }
  function mapItems(cart){
    return (cart.items||[]).slice(0,10).map(it=>({
      item_id:String(it.variant_id||it.product_id||it.id),
      item_name:it.product_title,
      item_variant:it.variant_title||"",
      item_brand:it.vendor||"",
      price:(it.price||0)/100,
      quantity:it.quantity||0
    }));
  }
// === RRX Rabatt-Helpers ===
const VCP_CACHE = new Map(); // variantId -> compare_at_price (cents)

async function getVariantCompareCents(variantId){
  if (!variantId) return 0;
  if (VCP_CACHE.has(variantId)) return VCP_CACHE.get(variantId);
  try{
    const res = await fetch(`/variants/${variantId}.js`, { credentials:"same-origin" });
    const v = await res.json();
    const c = Number(v?.compare_at_price) || 0; // cents (Shopify Variant JSON)
    VCP_CACHE.set(variantId, c);
    return c;
  } catch(_){
    VCP_CACHE.set(variantId, 0);
    return 0;
  }
}

function priceHTML(wasCents, nowCents){
  if ((wasCents||0) > (nowCents||0)){
    return `
      <span class="rrx-price-was" aria-hidden="true"><s>${moneyFmt(wasCents)}</s></span>
      <span class="rrx-price-now">${moneyFmt(nowCents)}</span>
    `;
  }
  return `<span class="rrx-price-now">${moneyFmt(nowCents||0)}</span>`;
}


async function computeCartSavings(cart){
  let total = 0;
  for (const it of (cart.items||[])){
    const qty     = it.quantity||1;
    const nowLine = it.final_line_price || it.line_price || ((it.price||0)*qty);

    let wasUnit = it.original_price || it.price || 0; // vor Cart-Discounts
    const cap   = await getVariantCompareCents(it.variant_id); // Produkt-Sale (compare_at_price)
    if (cap > wasUnit) wasUnit = cap;

    const wasLine = wasUnit * qty;
    const diff    = Math.max(0, wasLine - nowLine);
    total += diff;
  }
  return total; // cents
}
// === /RRX Rabatt-Helpers ===

  /* Items rendern */
function renderItems(cart){
  const wrap = drawer.querySelector("[data-rrx-items]");
  if (!wrap) return;

  // ======== LEERER WARENKORB ========
  if (!Array.isArray(cart.items) || cart.items.length === 0) {
    wrap.innerHTML = '<div class="rrx-empty-cols" data-rrx-empty-cols></div>';
    renderEmptyCollections();
    return;
  }

  // ======== NORMALER WARENKORB ========
  wrap.innerHTML = "";

  (cart.items || []).forEach(it => {
    const el = document.createElement("div");
    el.className = "rrx-item";

    // Metadaten für Tracking + QV
    el.dataset.handle       = it.handle || "";
    el.dataset.url          = it.url || "";
    el.dataset.key          = it.key;
    el.dataset.variantId    = it.variant_id || "";
    el.dataset.productId    = it.product_id || "";
    el.dataset.vendor       = it.vendor || "";
    el.dataset.title        = it.product_title || "";
    el.dataset.variantTitle = it.variant_title || "";
    el.dataset.unitPrice    = (it.price || 0);

    const src = imgUrl(
      it.image || (it.featured_image && (it.featured_image.url || it.featured_image)) || "",
      160
    );

    el.innerHTML = `
      <img src="${src}" alt="">
      <div>
        <p class="rrx-item-title">${it.product_title || ""}</p>
        <p class="rrx-item-meta">${it.variant_title || ""}</p>
        <div class="rrx-qty">
          <button type="button" data-act="dec" aria-label="Menge verringern">−</button>
          <input type="number" min="0" step="1" value="${it.quantity}" aria-label="Menge">
          <button type="button" data-act="inc" aria-label="Menge erhöhen">+</button>
        </div>
      </div>
      <div class="rrx-price" data-rrx-price>–</div>
    `;
    wrap.appendChild(el);
    // „war/jetzt“ – erst mit vorhandenen Daten rendern, dann ggf. mit compare_at nachziehen
{
  const priceEl = el.querySelector("[data-rrx-price]");
  const nowUnit = it.final_price || it.price || 0;
  let   wasUnit = it.original_price || it.price || 0;

  priceEl.innerHTML = priceHTML(wasUnit, nowUnit);

  // Produkt-Sale berücksichtigen (compare_at_price vom Variant JSON)
  getVariantCompareCents(it.variant_id).then(cap => {
    if (cap > wasUnit && cap > nowUnit){
      priceEl.innerHTML = priceHTML(cap, nowUnit);
    }
  });
}

  });

  // Events pro Item
  wrap.querySelectorAll(".rrx-item").forEach(row => {
    const key   = row.dataset.key;
    const input = row.querySelector("input");

    // Basisdaten für Events
    const base = {
      item_id: row.dataset.variantId || row.dataset.productId || key,
      item_name: row.dataset.title,
      item_variant: row.dataset.variantTitle,
      item_brand: row.dataset.vendor,
      price: (+row.dataset.unitPrice || 0) / 100
    };

    // GA4 immer, Meta Pixel nur bei "add"
    const fire = (type, qty) => {
      const item = { ...base, quantity: Math.abs(qty) };

      // GA4
      dl(type === "add" ? "add_to_cart" : "remove_from_cart", {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item]
      });

      // Meta Pixel nur bei "add"
      if (type === "add") {
        try {
  if (META_PIXEL_BRIDGE_ENABLED) {
    MPX.track("AddToCart", {
      /* >>> deine bestehende Payload hier UNVERÄNDERT lassen <<< */
      /* z. B. content_ids, content_type, value, currency, contents … */
    });
  }
} catch (_) {}
      }
    };

    row.querySelector("[data-act='dec']").addEventListener("click", () => {
      fire("remove", 1);
      updateQty(key, +input.value - 1);
    });

    row.querySelector("[data-act='inc']").addEventListener("click", () => {
      fire("add", 1);
      updateQty(key, +input.value + 1);
    });

    input.addEventListener("change", (e) => {
      const nv = +e.target.value;
      const ov = +(e.target.getAttribute("value") || 0);
      const diff = nv - ov;
      if (diff > 0) fire("add", diff);
      if (diff < 0) fire("remove", -diff);
      e.target.setAttribute("value", String(nv));
      updateQty(key, nv);
    });
  });
}

  function renderEmptyCollections(){
    const holder = drawer.querySelector('[data-rrx-empty-cols]');
    if(!holder) return;

    let cols = [];
    try { cols = JSON.parse(drawer.dataset.emptyCols || "[]"); } catch(_){}
    if(!Array.isArray(cols) || cols.length === 0){ holder.remove(); return; }

    holder.innerHTML = "";
    cols.slice(0,3).forEach((c, i) => {
      const handle = c?.handle || "";
      const title  = c?.title  || handle.replace(/-/g, " ");
      const img    = c?.image  || "";

      const a = document.createElement("a");
      a.className = "ec-card";
      a.href = handle ? (`/collections/${handle}`) : "#";
      a.style.setProperty("--i", String(i));

      a.innerHTML = `
        <div class="ec-media">
          ${ img ? `<img src="${img}" alt="">` : `<div class="ec-ph"></div>` }
        </div>
        <div class="ec-body">
          <div class="ec-title">${title}</div>
          <div class="ec-cta">Jetzt entdecken</div>
        </div>
      `;

      const imgEl = a.querySelector("img");
      if (imgEl) {
        imgEl.addEventListener("error", () => {
          a.querySelector(".ec-media").innerHTML = '<div class="ec-ph"></div>';
        }, { once:true });
      }

      holder.appendChild(a);
    });
  }

  async function updateQty(key, qty){
    qty = Math.max(0, qty);
    await fetch("/cart/change.js", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({id:key, quantity:qty}) });
    refresh(false);
  }

  /* Totals + Versand + Freebar */
  async function estimateShippingCents(subtotalCents){
    if (THRESHOLD > 0 && subtotalCents >= THRESHOLD) return 0;
    const flat = parseFloat(drawer.dataset.ship||"0")||0;
    return Math.round(flat*100);
  }
  async function renderTotals(cart){
    const subtotal = cart.total_price || 0; // cents
    drawer.querySelector("[data-rrx-subtotal]").textContent = moneyFmt(subtotal);
    // RRX: nominale Ersparnis rechts neben der Zwischensumme anzeigen
{
  const badge = drawer.querySelector("[data-rrx-savings]");
  if (badge){
    badge.hidden = true;
    computeCartSavings(cart).then(sav => {
      if (sav > 0){
        badge.textContent = "−" + moneyFmt(sav);
        badge.hidden = false;
      }
    });
  }
}


    const shippingCents = (cart.item_count||0) === 0 ? 0 : await estimateShippingCents(subtotal);

    const shipEl = drawer.querySelector("[data-rrx-shipping]");
    shipEl.innerHTML = (shippingCents===0)
      ? `<span class="rrx-free-inline">${drawer.dataset.freeText||"Gratis Versand!"}</span>`
      : moneyFmt(shippingCents);

    const grand = subtotal + (shippingCents||0);
    drawer.querySelector("[data-rrx-total]").textContent = moneyFmt(grand);

    const taxEl = drawer.querySelector(".rrx-taxnote");
    if (taxEl){
      const tpl = taxEl.getAttribute("data-tax-note") || taxEl.textContent || "";
      taxEl.textContent = tpl.replace("{vat}", String(VAT).replace(".",","));
    }

    const fill = drawer.querySelector(".rrx-freebar-fill");
    const knob = drawer.querySelector(".rrx-freebar-knob");
    const remainEl = drawer.querySelector(".rrx-remain");
    if (THRESHOLD > 0 && fill && knob && remainEl){
      const p = Math.min(100, Math.round(subtotal*100/THRESHOLD));
      fill.style.width = p + "%";
      knob.style.left  = p + "%";
      const remain = Math.max(0, THRESHOLD - subtotal);
      const reached = remain <= 0;
      remainEl.textContent = reached ? "0,00 €" : moneyFmt(remain);

      const preEl  = drawer.querySelector(".rrx-pre");
      const postEl = drawer.querySelector(".rrx-post");
      if (preEl && postEl){
        if (FREEBAR_SUFFIX || FREEBAR_REACHED) {
          postEl.textContent = reached ? (FREEBAR_REACHED || postEl.textContent) : (FREEBAR_SUFFIX || postEl.textContent);
        }
        preEl.style.display = reached ? "none" : "";
      }
    }
  }

  /* ───── Swatch-Resolver ───── */

  // 1) Farben → Hex als absoluter Fallback
  const COLOR_HEX = {
    weiss:"#ffffff","weiß":"#ffffff",white:"#ffffff",
    schwarz:"#000000",black:"#000000",
    grau:"#9aa3ab",gray:"#9aa3ab",grey:"#9aa3ab",
    "heather grey":"#cfcfcf","mid heather grey":"#b8b8b8","dark heather grey":"#8a8a8a",
    rot:"#c62828",red:"#c62828",burgundy:"#6d0019",
    blau:"#1565c0",blue:"#1565c0",navy:"#1f2a44","french navy":"#1f2a44",
    "royal blue":"#2c5fb8","sky blue":"#8ec5e8",
    grün:"#2e7d32",gruen:"#2e7d32",green:"#2e7d32","bottle green":"#2d5c4d","green bay":"#3a5f55",
    sage:"#9caf88","aloe":"#6f8f85","stargazer":"#596e6e",
    beige:"#c8c1ae",sand:"#c8c1ae","desert dust":"#e3d6c7",
    khaki:"#8b8c6d","mid heather khaki":"#9b9a7a",
    "cotton pink":"#f4c7c3","cream heather pink":"#ead7d2",
    "mid heather blue":"#6f7f9b","stone blue":"#597a8b","blue soul":"#8eb5d9",
    "opal":"#a3c3be","natural raw":"#efe8d8","natural":"#efe7da",
    mustard:"#d5a824"
  };
  const guessColor = (label)=>{
    const t=(label||"").toString().trim().toLowerCase();
    const hex=t.match(/#([0-9a-f]{3,8})/i); if (hex) return hex[0];
    return COLOR_HEX[t] || "#ddd";
  };

  // 2) Globale Map (+ Sonderfall)
  const GLOBAL_SWATCH_MAP = (() => {
    const base = (window.__RRX_SWATCH_MAP__ && typeof window.__RRX_SWATCH_MAP__ === "object") ? window.__RRX_SWATCH_MAP__ : {};
    return Object.assign(base, {
      "fraiche-peche": "https://cdn.shopify.com/s/files/1/0762/5343/0089/files/FRAICHE-PECHE.png?v=1715326894"
    });
  })();

  // 2b) Basisfarben → Vollton (kein Theme-Foto)
  const BASIC_HEX_SWATCHES = new Set(["black","schwarz","white","weiss","weiß"]);

  // 3) Theme-CSS nach echten background-image-Regeln scannen
  function themeSwatchUrlFromCSS(handle){
    const h = handle.toLowerCase();
    const selectorsToLookFor = [
      `[data-swatch="${h}"]`, `[data-swatch-handle="${h}"]`,
      `.color-swatch__item--${h}`, `.color-swatch--${h}`, `.product-form__swatch--${h}`,
      `.swatch-${h}`, `.is-swatch-${h}`
    ];
    try{
      for (const ss of Array.from(document.styleSheets)){
        let rules; try{ rules = ss.cssRules || ss.rules; }catch(_){ continue; } // CORS
        if (!rules) continue;
        for (const r of Array.from(rules)){
          if (!r || !r.selectorText || !r.style) continue;
          const bg = r.style.backgroundImage || "";
          if (!bg || !bg.includes("url(")) continue;
          if (!selectorsToLookFor.some(sel => r.selectorText.includes(sel))) continue;
          const m = bg.match(/url\((['"]?)(.*?)\1\)/i);
          if (m && m[2]) return m[2];
        }
      }
    }catch(_){}
    return "";
  }

  // 4) Bild-Existenz testen
  function probeImage(url, timeoutMs=350){
    return new Promise((res)=>{
      const img = new Image();
      let done=false, t=setTimeout(()=>{ if(!done){done=true;res(false);} }, timeoutMs);
      img.onload = ()=>{ if(!done){ done=true; clearTimeout(t); res(true);} };
      img.onerror= ()=>{ if(!done){ done=true; clearTimeout(t); res(false);} };
      img.src = url;
    });
  }
  async function firstExistingUrl(urls){
    for (const u of urls){ if (await probeImage(u)) return u; }
    return "";
  }

  // 5) Swatch-URL robust auflösen
  async function resolveSwatchUrl(label){
    const h   = handleize(label);
    const hex = guessColor(label);

    // a) explizite Map
    if (GLOBAL_SWATCH_MAP && GLOBAL_SWATCH_MAP[h]){
      const mapped = GLOBAL_SWATCH_MAP[h];
      const full   = mapped.startsWith("http")||mapped.startsWith("/") ? mapped : cdnFile(mapped);
      if (await probeImage(full)) return full;
    }

    // b) Basisfarben → Vollton
    if (BASIC_HEX_SWATCHES.has(h)) {
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><rect width='20' height='20' fill='${hex}'/></svg>`
      )}`;
    }

    // c) Theme-CSS
    const cssUrl = themeSwatchUrlFromCSS(h);
    if (cssUrl) return cssUrl;

    // d) /files Kandidaten
    const title = titleizeHandle(h);
    const exts  = ["png","jpg","jpeg","webp"];
    const cand  = [];
    exts.forEach(ext=>{ cand.push(cdnFile(`${h}.${ext}`)); cand.push(cdnFile(`${title}.${ext}`)); });
    const found = await firstExistingUrl(cand);
    if (found) return found;

    // e) Fallback: Hex
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><rect width='20' height='20' fill='${hex}'/></svg>`
    )}`;
  }

  /* ───────────── Quick-View (ohne Preis) + Zoom-Overlay ───────────── */

  const QV      = byId("rrx-qv");
  const QV_BODY = QV?.querySelector(".rrx-qv-body");
  function closeQuickView(){ if (!QV) return; QV.setAttribute("aria-hidden","true"); if (QV_BODY) QV_BODY.innerHTML = ""; }
  QV?.querySelector(".rrx-qv-close")?.addEventListener("click", closeQuickView);
  QV?.querySelector(".rrx-qv-backdrop")?.addEventListener("click", closeQuickView);

  function productUrl(p){ return p.url || (p.handle ? (`/products/${p.handle}`) : "#"); }
  function productImage(p){ const src=(p.featured_image && (p.featured_image.src || p.featured_image)) || p.image || (p.images?.[0]||""); return imgUrl(src, 540); }
  function productImageXL(p){ const src=(p.featured_image && (p.featured_image.src || p.featured_image)) || p.image || (p.images?.[0]||""); return imgUrl(src, 1600); }

  function openQuickView(p){
    const QV      = document.getElementById("rrx-qv");
    const QV_BODY = QV?.querySelector(".rrx-qv-body");
    const drawer  = document.getElementById("rrx-cart-drawer");
    if (!drawer || !QV || !QV_BODY) return;
    if ((drawer.dataset.quick||"true")!=="true") return;


    // Helfer
    const options  = Array.isArray(p?.options)  ? p.options  : [];
    const variants = Array.isArray(p?.variants) ? p.variants : [];
    const imgUrlW = (src,w)=>{ try{ const u=new URL(src,location.origin); if(w) u.searchParams.set("width",String(w)); return u.toString(); }catch(_){ return src; } };
    const productImg = (pp,w)=>{ const s=(pp?.featured_image&&(pp.featured_image.src||pp.featured_image))||pp?.image||(pp?.images?.[0]||""); return imgUrlW(s,w); };
    const varImg = (v,w)=> imgUrlW(
      (v?.featured_image && (v.featured_image.src||v.featured_image)) || v?.image ||
      (p?.featured_image && (p.featured_image.src||p.featured_image)) || p?.image || (p?.images?.[0]||""),
      w
    );

    // Start-Variante/Selektion
    let active   = variants.find(v=>v.available) || variants[0] || null;
    let selected = (active?.options || []).slice();

    // ======== NEU: Größen-Verfügbarkeits-Controller (nicht zerstörend) ========
    let SIZE_IDX = -1;
    let sizeBlock = null;

    function markSizeAvailability(){
      if (SIZE_IDX < 0 || !sizeBlock) return;

      // verfügbare Größen – gefiltert nach allen anderen Optionswerten
      const avail = new Set();
      (variants || []).forEach(v => {
        if (!v?.available) return;
        let ok = true;
        (v.options || []).forEach((val, i) => {
          if (i === SIZE_IDX) return;
          if (selected[i] && selected[i] !== val) ok = false;
        });
        if (ok) avail.add(String(v.options[SIZE_IDX]).trim().toLowerCase());
      });

      const btns = sizeBlock.querySelectorAll(".qv-opt-btn");
      let firstAvailBtn = null;

      btns.forEach(btn => {
        const val = (btn.dataset.value || btn.textContent || "").trim().toLowerCase();
        const ok  = avail.has(val);

       // ok = Größe verfügbar (boolean)
btn.classList.toggle("soldout", !ok);
btn.toggleAttribute("disabled", !ok);           // nicht anklickbar
btn.setAttribute("aria-disabled", !ok ? "true" : "false");

// Sicherheit: aktive Klasse nur auf verfügbare Buttons
if (!ok) btn.classList.remove("is-active");


      

        if (ok && !firstAvailBtn) firstAvailBtn = btn;
      });

      // Falls aktuelle Größe nicht mehr passt → erste verfügbare aktivieren
      const cur = (selected[SIZE_IDX] || "").trim().toLowerCase();
      if (!avail.has(cur) && firstAvailBtn){
        selected[SIZE_IDX] = firstAvailBtn.dataset.value || firstAvailBtn.textContent;
        btns.forEach(b => b.classList.remove("is-active"));
        firstAvailBtn.classList.add("is-active");
        updateVariant();
        updateImagePreview();
      }
    }
    // ======== ENDE NEU ========

    // Markup
    QV_BODY.innerHTML = `
      <div class="rrx-qv-head" style="text-align:center">
        <figure class="qv-pic">
          <img class="qv-img" src="${productImg(p,540)}" alt="${(p?.title||'').replace(/"/g,'&quot;')}">
          <button class="rrx-qv-eye" type="button" aria-label="Bild vergrößern" title="Bild vergrößern"><span aria-hidden="true"></span></button>
        </figure>
        <h3 class="qv-title">${p?.title||""}</h3>
      </div>
      <div class="rrx-qv-options"></div>
      <div class="qv-actions">
        <button class="rrx-btn rrx-btn--xl" data-qv-add disabled><span>In den Warenkorb</span></button>
        <div class="qv-share" data-qv-share></div>
      </div>
    `;

    const imgEl  = QV_BODY.querySelector(".qv-img");
    const eyeBtn = QV_BODY.querySelector(".rrx-qv-eye");
    const addBtn = QV_BODY.querySelector("[data-qv-add]");
    const optWrap= QV_BODY.querySelector(".rrx-qv-options");

    // Variant/Preview Logik
    function previewCandidate(){
      const cand = variants.filter(v => (v.options||[]).every((o,i)=> !selected[i] || o===selected[i]));
      return cand.find(v=>v.available) || cand[0] || active || variants[0] || null;
    }
    function updateVariant(){
      active = variants.find(v => (v.options||[]).every((o,i)=>o===selected[i])) || null;
      addBtn.disabled = !active || active.available===false;
    }
    function updateImagePreview(){
      const v = previewCandidate();
      const sm = varImg(v,540);
      const xl = varImg(v,1600);
      if (imgEl && imgEl.src !== sm) imgEl.src = sm;
      if (eyeBtn){ eyeBtn.onclick = ()=> openZoom(xl); }
    }
    function updateColorLabelTitles(){
      optWrap.querySelectorAll(".qv-opt").forEach((optEl,optIdx)=>{
        const isColor = /(^|[^a-z])(farbe|color)([^a-z]|$)/i.test(optEl.dataset.name||"");
        if (!isColor) return;
        const lab = optEl.querySelector(".qv-opt-label");
        if (lab) lab.textContent = selected[optIdx] || optEl.dataset.name || "Farbe";
      });
    }

    // Optionen aufbauen
    options.forEach((opt, idx) => {
      const label   = (opt?.name || opt || "").toString();
      const isColor = /(^|[^a-z])(farbe|color)([^a-z]|$)/i.test(label);
      const isSize  = /(größe|groesse|size)/i.test(label);
      const values  = Array.from(new Set(variants.map(v => v.options?.[idx]).filter(Boolean)));

      const block = document.createElement("div");
      block.className   = "qv-opt";
      block.dataset.name= label;
      if (isColor) block.classList.add("qv-opt--color");
      if (isSize)  block.classList.add("qv-opt--size");
      block.innerHTML = `<div class="qv-opt-label">${label}</div><div class="qv-opt-values"></div>`;
      const row = block.querySelector(".qv-opt-values");

      // merken, wo der Größenblock ist (für das Ausblenden)
      if (isSize) { SIZE_IDX = idx; sizeBlock = block; }

      values.forEach(v => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "qv-opt-btn";
        b.textContent = v;
        b.dataset.value = v; // <- für markSizeAvailability

        // Swatch-Kreise
        if (isColor){
          const h = (String(v)||"").trim().toLowerCase()
            .normalize("NFD").replace(/[\u0300-\u036f]/g,"")
            .replace(/[^a-z0-9]+/g,"-").replace(/(^-|-$)/g,"");
          const fallback = guessColor(v);
          b.dataset.swatchH = h;
          b.style.setProperty("--swatch", fallback);
          b.setAttribute("aria-label", v);
          b.textContent = "";
          (async()=>{ try{
            const u = await resolveSwatchUrl(v);
            if (u){ b.style.backgroundImage=`url("${u}")`; b.style.backgroundSize="cover"; b.style.backgroundPosition="center"; b.style.backgroundRepeat="no-repeat"; }
          }catch(_){}})();
        }

        if (isSize && v.trim().length > 3) b.classList.add("is-pill");
        if ((selected[idx]||"") === v) b.classList.add("is-active");

        b.addEventListener("click", () => {
          row.querySelectorAll(".qv-opt-btn").forEach(x => x.classList.remove("is-active"));
          b.classList.add("is-active");
          selected[idx] = v;
          updateVariant();
          updateColorLabelTitles();
          updateImagePreview();
          markSizeAvailability(); // <- NEU: nach jeder Auswahl neu prüfen
        });

        row.appendChild(b);
      });

      optWrap.appendChild(block);
    });

    updateVariant();
    updateColorLabelTitles();
    updateImagePreview();
    markSizeAvailability(); // <- NEU: initial ausführen

    // Add to cart
addBtn.addEventListener("click", async () => {
  if (!active) return;

  // GA4 + (optional) Meta Pixel
  const price = toCents(active.price || 0) / 100;
  const item = {
    item_id: String(active.id),
    item_name: p?.title || "",
    item_variant: active?.title || "",
    item_brand: p?.vendor || "",
    price,
    quantity: 1
  };
  dl("add_to_cart", { currency: CURRENCY, value: price, items: [item] });

  // Shopify-Bus/trekkie einmal sicher feuern
  try { window.RRXFireATCOnce?.({ id: active.id, quantity: 1 }); } catch (_) {}

  // Meta Pixel (optional, über Flag)
  try {
    if (META_PIXEL_BRIDGE_ENABLED) {
      MPX.track("AddToCart", {
        // deine bestehende Payload hier (content_ids, value, currency, contents …)
      });
    }
  } catch (_) {}

  // EINMALIG add.js call (Doppelaufruf entfernt)
  await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ id: active.id, quantity: 1 })
  }).catch(()=>{});

  // UI
  QV.setAttribute("aria-hidden","true");
  window.RRXCartDrawer?.refresh?.(false);
  window.RRXCartDrawer?.open?.();
});



    // Share
    (function renderShare(){
      const wrap = QV_BODY.querySelector("[data-qv-share]");
      if (!wrap) return;
      const url = location.origin + (p?.url || (p?.handle ? `/products/${p.handle}` : "#"));
      const txt = encodeURIComponent(p?.title || document.title);
      const img = encodeURIComponent(productImg(p,540));
      const add = (cls,title,href,txtc)=>{ const a=document.createElement("a"); a.className=`qv-share-btn ${cls}`; a.href=href; a.target="_blank"; a.rel="noopener"; a.title=title; a.textContent=txtc; wrap.appendChild(a); };
      if ((drawer.dataset.shareFb||"true")==="true") add("fb","Facebook",`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,"f");
      if ((drawer.dataset.sharePinterest||drawer.dataset.sharePin||"true")==="true") add("pin","Pinterest",`https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${img}&description=${txt}`,"P");
      if ((drawer.dataset.shareWhatsapp||drawer.dataset.shareWa||"true")==="true") add("wa","WhatsApp",`https://wa.me/?text=${txt}%20-%20${encodeURIComponent(url)}`,"WA");
      if ((drawer.dataset.shareEmail||drawer.dataset.shareMail||"true")==="true") add("mail","E-Mail",`mailto:?subject=${txt}&body=${txt}%0A%0A${encodeURIComponent(url)}`,"@");
    })();

    // Zoom-Overlay binden
    ensureZoomOverlay();
    QV.setAttribute("aria-hidden","false");
    QV.querySelector(".rrx-qv-close")?.addEventListener("click", ()=> QV.setAttribute("aria-hidden","true"), {once:true});
    QV.querySelector(".rrx-qv-backdrop")?.addEventListener("click", ()=> QV.setAttribute("aria-hidden","true"), {once:true});
  }

  /* Empfehlungen */
  function designKeyFromTags(tags){
    if(!tags) return "";
    const arr = Array.isArray(tags) ? tags : String(tags).split(",").map(s=>s.trim());
    for (const t of arr){
      const s = t.toLowerCase();
      const m = s.match(/^(?:kollektions?\s*[-\s_]*)?design[:\-\s_]*(.+)$/i);
      if (m && m[1]) return "design::"+m[1].trim();
      if (s.startsWith("design-")) return "design::"+s.slice(7);
      if (s.startsWith("design_")) return "design::"+s.slice(7);
    }
    return "";
  }
  async function ensureDesignKey(p){
    let dk = designKeyFromTags(p.tags || p.tag);
    if (dk) return dk;
    try{
      const full = await fetch(`/products/${encodeURIComponent(p.handle || extractHandleFromUrl(p.url))}.js`).then(r=>r.json());
      dk = designKeyFromTags(full.tags);
      if (dk) return dk;
    }catch(_){}
    return "h::"+(p.handle||extractHandleFromUrl(p.url)||"").toLowerCase();
  }
  function clampReco(){
    const box = drawer.querySelector("[data-rrx-reco]");
    if (!box) return;
    const items = [...box.querySelectorAll(".reco-item")];
    items.forEach((el,i)=>{ if(i>=RECO_MAX) el.remove(); });
  }
  function observeReco(){
    const box = drawer.querySelector("[data-rrx-reco]");
    if (!box) return;
    clampReco();
    new MutationObserver(()=>clampReco()).observe(box,{childList:true});
  }

  async function renderRecs(cart){
    const box = drawer.querySelector("[data-rrx-reco]");
    if (!box) return;
    box.innerHTML = "";

    const inCart = new Set((cart.items||[]).map(i=>i.handle||extractHandleFromUrl(i.url)).filter(Boolean));
    const picked = [];
    const seenH  = new Set();
    const seenD  = new Set();

    function pushIfOk(p){
      const handle = p.handle || extractHandleFromUrl(p.url);
      if (!handle || inCart.has(handle) || seenH.has(handle)) return false;
      seenH.add(handle);
      picked.push(p);
      return true;
    }

    // 3a) Empfehlungen zum ersten Cart-Artikel
    if ((cart.items||[]).length > 0 && (cart.items[0]?.product_id)){
      try{
        const data = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(cart.items[0].product_id)}&limit=24`).then(r=>r.json());
        const all  = Array.isArray(data.products) ? data.products : [];

        for (const p of all){
          if (picked.length>=RECO_MAX) break;
          const handle = p.handle || extractHandleFromUrl(p.url); if (!handle) continue;
          const dkey   = await ensureDesignKey(p);
          if (seenD.has(dkey)) continue;
          seenD.add(dkey);
          pushIfOk(p);
        }
        for (const p of all){ if (picked.length>=RECO_MAX) break; pushIfOk(p); }
      }catch(_){}
    }

    // 3b) Leer / nicht genug Picks → „Angesehen“
    if (picked.length < RECO_MAX){
      try{
        const raw = localStorage.getItem("rrx_recent_handles") || "";
        const handles = dedupeLatestFirst(raw.split(",").filter(Boolean)).reverse();
        for (const h of handles){
          if (picked.length>=RECO_MAX) break;
          try{
            const p = await fetch(`/products/${encodeURIComponent(h)}.js`).then(r=>r.json());
            const norm = { handle:p.handle, title:p.title, url:p.url, featured_image:p.featured_image, images:p.images, variants:p.variants };
            const dkey = await ensureDesignKey(norm);
            if (seenD.has(dkey)) continue;
            seenD.add(dkey);
            pushIfOk(norm);
          }catch(_){}
        }
      }catch(_){}
    }

    // 3c) Fallback: Bestseller / alle Produkte
    if (picked.length < RECO_MAX){
      const bestHandle = (drawer.dataset.bestHandle || drawer.dataset.bestsellers || drawer.dataset.best || "bestseller");
      let list = [];
      try{
        const data = await fetch(`/collections/${encodeURIComponent(bestHandle)}/products.json?limit=24`).then(r=>r.json());
        list = Array.isArray(data.products) ? data.products : [];
      }catch(_){}
      if (!list.length){
        try{
          const data = await fetch(`/products.json?limit=24`).then(r=>r.json());
          list = Array.isArray(data.products) ? data.products : [];
        }catch(_){}
      }
      for (const p of list){
        if (picked.length>=RECO_MAX) break;
        pushIfOk(p);
      }
    }

    // Rendern
    picked.forEach(p=>{
      const handle = p.handle || extractHandleFromUrl(p.url) || "";
      const img    = (p.featured_image && (p.featured_image.src || p.featured_image)) || p.image || p.images?.[0] || "";
      const row = document.createElement("div");
      row.className = "reco-item";
      row.dataset.handle = handle;
      row.innerHTML = `
        <div class="reco-img"><img src="${imgUrl(img,200)}" alt=""></div>
        <div class="reco-info">
          <div class="reco-ttl">${p.title||""}</div>
          <div class="reco-prc">${moneyFmt(toCents(p.price ?? p.variants?.[0]?.price))}</div>
        </div>
        ${QV_ENABLE?`<button class="rrx-quick-btn rrx-peel" type="button" data-handle="${handle}" aria-label="Schnellansicht"><span aria-hidden="true"></span></button>`:""}
      `;
      row.addEventListener("click",(ev)=>{
        if (ev.target.closest(".rrx-peel")){ ev.preventDefault(); ev.stopPropagation(); }
      }, true);
      box.appendChild(row);
    });

    observeReco();
    syncRecoCarousel();
  }

  /* Angesehen */
  function dedupeLatestFirst(list){
    const seen=new Set(), out=[];
    for (let i=list.length-1; i>=0; i--){
      const h=list[i];
      if (h && !seen.has(h)){ seen.add(h); out.push(h); }
    }
    return out.reverse();
  }
  async function renderRecent(){
    const box = drawer.querySelector("[data-rrx-recent]");
    if (!box) return;

    const raw = localStorage.getItem("rrx_recent_handles") || "";
    const handles = dedupeLatestFirst(raw.split(",").filter(Boolean)).slice(0,20);

    box.innerHTML = handles.length ? "" : "<p style='padding:12px'>Noch nichts angesehen.</p>";

    for (const h of handles){
      try{
        const p   = await fetch(`/products/${encodeURIComponent(h)}.js`).then(x=>x.json());
        const pic = imgUrl((p.featured_image||""), 420);

        const a = document.createElement("a");
        a.href = p.url;
        a.innerHTML = `
          <img class="rrx-recent-img" src="${pic}" alt="">
          <div class="ttl" style="font-weight:600;margin:6px 0 2px">${p.title}</div>
          <div class="prc">${moneyFmt(toCents(p.variants?.[0]?.price))}</div>
        `;
        if (QV_ENABLE){
          const peel = document.createElement("button");
          peel.type = "button";
          peel.className = "rrx-quick-btn rrx-peel";
          peel.setAttribute("aria-label","Schnellansicht");
          peel.dataset.handle = p.handle;
          peel.innerHTML = '<span aria-hidden="true"></span>';
          a.appendChild(peel);
        }
        box.appendChild(a);

        a.addEventListener("click",(ev)=>{
          if (ev.target.closest(".rrx-peel")){
            ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation?.();
            fetch(`/products/${encodeURIComponent(p.handle)}.js`)
              .then(r=>r.json()).then(openQuickView).catch(()=>{});
            return;
          }
          ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation?.();
        }, true);

      }catch(_){}
    }
  }




  drawer.addEventListener("click", (e) => {
  // 1) Quick-View über Peel-Button
  const peel = e.target.closest(".rrx-peel");
  if (peel) {
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
    const handle = peel.dataset.handle
      || peel.closest("[data-handle]")?.dataset.handle
      || extractHandleFromUrl(peel.closest("a")?.href || "");
    if (!handle) return;
    fetch(`/products/${encodeURIComponent(handle)}.js`)
      .then(r => r.json())
      .then(openQuickView)
      .catch(() => {});
    return;
  }

  // 2) Klick auf Warenkorb-Artikel öffnet Quick-View
  const row = e.target.closest(".rrx-item");
  if (row && !e.target.closest(".rrx-qty")) { // nicht auslösen bei +/- oder Eingabe
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
    const handle =
      row.dataset.handle
      || extractHandleFromUrl(row.dataset.url || "")
      || extractHandleFromUrl(row.querySelector("a")?.href || "");
    if (!handle) return;
    fetch(`/products/${encodeURIComponent(handle)}.js`)
      .then(r => r.json())
      .then(openQuickView)
      .catch(() => {});
  }
}, true);


  /* Reco-Karussell mobil */
  const MOBILE_MQ = window.matchMedia("(max-width: 760px)");
  let __rrxCarousel = false;
  let __rrxCarouselNav = null;
  function ensureRecoWrap(){
    const reco = drawer.querySelector("[data-rrx-reco]");
    if (!reco) return null;
    if (reco.parentElement?.classList.contains("rrx-reco-wrap")) return reco.parentElement;
    const wrap = document.createElement("div"); wrap.className = "rrx-reco-wrap";
    reco.parentNode.insertBefore(wrap, reco); wrap.appendChild(reco); return wrap;
  }
  function carouselStep(reco){
    const gap  = parseFloat(getComputedStyle(reco).gap || "12") || 12;
    const card = reco.querySelector(".reco-item");
    if (!card) return Math.round(reco.clientWidth*0.86);
    return Math.ceil(card.getBoundingClientRect().width + gap);
  }
  function updateRecoNav(reco){
    if (!__rrxCarouselNav) return;
    const max = Math.max(0, reco.scrollWidth - reco.clientWidth - 2);
    const x   = reco.scrollLeft || 0;
    const prev = __rrxCarouselNav.querySelector(".rrx-c-prev");
    const next = __rrxCarouselNav.querySelector(".rrx-c-next");
    prev.classList.toggle("is-hidden", x <= 1);
    next.classList.toggle("is-hidden", x >= max);
  }
  function makeRecoCarousel(){
    if (!MOBILE_MQ.matches) return teardownRecoCarousel();
    const reco = drawer.querySelector("[data-rrx-reco]");
    if (!reco || reco.children.length < 2) return;
    const wrap = ensureRecoWrap();
    reco.setAttribute("data-carousel","1");
    if (!__rrxCarouselNav){
      const nav = document.createElement("div");
      nav.className = "rrx-reco-nav";
      nav.innerHTML = `
        <button type="button" class="rrx-c-btn rrx-c-prev" aria-label="Zurück">‹</button>
        <button type="button" class="rrx-c-btn rrx-c-next" aria-label="Weiter">›</button>
      `;
      wrap.appendChild(nav);
      __rrxCarouselNav = nav;
      nav.querySelector(".rrx-c-prev").addEventListener("click",()=>{ const r=drawer.querySelector("[data-rrx-reco]"); r && r.scrollBy({left:-carouselStep(r), behavior:"smooth"}); });
      nav.querySelector(".rrx-c-next").addEventListener("click",()=>{ const r=drawer.querySelector("[data-rrx-reco]"); r && r.scrollBy({left: carouselStep(r), behavior:"smooth"}); });
    }
    const r2 = drawer.querySelector("[data-rrx-reco]");
    if (r2) {
      updateRecoNav(r2);
      r2.addEventListener("scroll", ()=>updateRecoNav(r2), {passive:true});
      window.addEventListener("resize", ()=>updateRecoNav(r2));
    }
    __rrxCarousel = true;
  }
  function teardownRecoCarousel(){
    const reco = drawer.querySelector("[data-rrx-reco]");
    if (!reco) return;
    reco.removeAttribute("data-carousel");
    if (__rrxCarouselNav){ __rrxCarouselNav.remove(); __rrxCarouselNav = null; }
    __rrxCarousel = false;
  }
  function syncRecoCarousel(){ if (MOBILE_MQ.matches) makeRecoCarousel(); else teardownRecoCarousel(); }
  MOBILE_MQ.addEventListener ? MOBILE_MQ.addEventListener("change", syncRecoCarousel) : MOBILE_MQ.addListener(syncRecoCarousel);

  /* Refresh + GA */
  async function refresh(openedByUi){
  const cart = await getCart();
  renderItems(cart);

  await renderTotals(cart);
  const subtotal      = cart.total_price || 0;
  const itemCount     = cart.item_count  || 0;
  const shippingCents = itemCount === 0 ? 0 : await estimateShippingCents(subtotal);

  await renderRecs(cart);

  LAST_CART = cart;
  window.LAST_CART = cart;

  // Express-Buttons initialisieren + Sichtbarkeit korrigieren
  initExpressButtonsSafely();
  fixExpressVisibility();
  ensureExpressObserver(); // Observer nur 1× anlegen

  if (drawer.getAttribute("aria-hidden") === "false"){
    dl("view_cart", {
      currency: CURRENCY,
      value: (cart.total_price || 0) / 100,
      items: mapItems(cart),
      item_count: cart.item_count || 0,
      cart_token: cart.token || undefined
    });
    if (openedByUi) dl("rrx_cart_drawer_open", { source: "ui" });
  }
}



/* === Begin Checkout – submit-only & single-fire === */
window.__RRX_BEGIN_CHECKOUT_ONCE__ = (() => {
  let lastTs = 0;                      // schützt vor Doppel-Submit (z.B. Doppelklick)
  return function () {
    const now = Date.now();
    if (now - lastTs < 2500) return;   // 2.5s Schutzfenster
    lastTs = now;

try {
  if (META_PIXEL_BRIDGE_ENABLED && typeof window.fbq === "function") {
    const icEventID = MPX.id(); // stabile eindeutige ID
    window.fbq(
      "track",
      "InitiateCheckout",
      {
        // deine bestehende Payload (currency, value, contents, num_items …)
      },
      { eventID: icEventID }
    );
  }
} catch (_) {}


  };
})();
// Submit → Tracking nur 1× beim echten Formular-Submit
// Delegiert: feuert bei jedem Submit des Checkout-Forms im Drawer (1× guarded)
drawer.addEventListener('submit', (ev) => {
  const form = ev.target.closest('form[data-rrx="checkout-form"]');
  if (!form) return;
  window.__RRX_BEGIN_CHECKOUT_ONCE__?.();
}, true); // capture, damit es vor der Navigation läuft



  document.addEventListener("DOMContentLoaded",()=>{
    try{
      const meta = document.querySelector('meta[property="og:url"]')?.content || location.pathname;
      const m    = meta.match(/\/products\/([^\/?#]+)/);
      if (m){
        const h = m[1];
        const k = "rrx_recent_handles";
        const arr = (localStorage.getItem(k)||"").split(",").filter(Boolean);
        arr.push(h);
        localStorage.setItem(k, arr.join(","));
      }
    }catch(_){}
  });

  if (!IN_EDITOR){ refresh(false); }

  /* ===== Zoom-Overlay (Eye) – CSS + DOM + Helpers ===== */
  function ensureZoomOverlay(){
    if (byId("rrx-qv-zoom")) return;
    const z = document.createElement("div");
    z.id = "rrx-qv-zoom";
    z.setAttribute("aria-hidden","true");
    z.innerHTML = `
      <div class="zoom-bd">
        <button class="zoom-x" aria-label="Schließen" title="Schließen">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>
        </button>
        <img class="zoom-img" alt="">
      </div>
    `;
    document.body.appendChild(z);
    const bd = z.querySelector(".zoom-bd");
    bd?.addEventListener("click",(e)=>{ if (!e.target.closest(".zoom-img")) closeZoom(); }, {capture:true});
    z.querySelector(".zoom-img")?.addEventListener("click",(e)=> e.stopPropagation());
    z.querySelector(".zoom-x")?.addEventListener("click", closeZoom);
  }
  function openZoom(src){
    const z = byId("rrx-qv-zoom"); if (!z) return;
    const img = z.querySelector(".zoom-img");
    img.src = src || "";
    z.setAttribute("aria-hidden","false");
    document.documentElement.style.setProperty("--rrx-zoom-open","1");
  }
  function closeZoom(){
    const z = byId("rrx-qv-zoom"); if (!z) return;
    z.setAttribute("aria-hidden","true");
    document.documentElement.style.removeProperty("--rrx-zoom-open");
  }

  /* Minimaler Style-Block für QV-Layout + Zoom + Reco-Nav (rest in Section-CSS) */
  try{
    const s = document.createElement("style");
    s.textContent = `
    
      /* QV: Karte <= 86vh, Inhalt scrollt intern */
      #rrx-cart-drawer .rrx-qv-card{ position:relative; display:grid; grid-template-rows:auto 1fr; width:min(740px,92vw); max-height:86vh; overflow:hidden; }
      #rrx-cart-drawer .rrx-qv-body{ overflow-y:auto; overflow-x:hidden; padding-inline:0; padding-bottom:8px; box-sizing:border-box; }
      #rrx-cart-drawer .rrx-qv-head{ display:grid; grid-template-columns:1fr; gap:12px; place-items:center; text-align:center; margin-bottom:8px; }
      #rrx-cart-drawer .qv-pic{ position:relative; display:inline-block; }
      #rrx-cart-drawer .qv-img{
        width:auto; height:auto; object-fit:contain; display:block; background:#fff; border-radius:12px;
        margin-inline:auto; max-width:min(92%, 640px); max-height:clamp(220px, var(--qv-img, 420px), 60vh);
      }
      @media (max-width:760px){
        #rrx-cart-drawer .qv-img{ max-width:84%; max-height:min(34vh, 340px); }
        #rrx-cart-drawer .rrx-qv-head{ gap:8px; margin-bottom:6px; }
        #rrx-cart-drawer .qv-opt{ margin-top:8px; }
        #rrx-cart-drawer .qv-opt--color .qv-opt-values{ gap:10px; }
        #rrx-cart-drawer .qv-opt--color .qv-opt-btn{ width:32px; height:32px; }
        #rrx-cart-drawer .qv-opt--size .qv-opt-btn{ width:40px; height:38px; }
        #rrx-cart-drawer .qv-opt--size .qv-opt-btn.is-pill{ width:auto; min-width:56px; height:38px; padding:0 10px; border-radius:999px; }
        #rrx-cart-drawer .qv-actions{ margin-top:10px; }
        #rrx-cart-drawer .qv-actions{ max-width:100%; }
        #rrx-cart-drawer .qv-actions > *{ max-width:100%; }
        #rrx-cart-drawer .rrx-btn--xl{ width:100%; max-width:100%; }
      }

      #rrx-cart-drawer .qv-opt-btn{
        padding:10px 14px; border:1px solid #dfe3e8; border-radius:999px; background:#fff; cursor:pointer;
        transition:transform .12s ease, box-shadow .18s ease, background .18s ease, color .18s ease, border-color .18s ease;
      }
      #rrx-cart-drawer .qv-opt-btn:hover{ transform:translateY(-1px); box-shadow:0 6px 14px rgba(0,0,0,.10); }
      #rrx-cart-drawer .qv-opt--size .qv-opt-btn.is-active{ background:#fff; color:var(--ac); border-color:var(--ac); box-shadow:0 0 0 3px rgba(46,125,50,.12); }
      #rrx-cart-drawer .qv-opt--color .qv-opt-btn{ width:36px; height:36px; padding:0; border-radius:999px; border:2px solid #e3e6ea; background-color: var(--swatch); box-shadow: inset 0 0 0 1px rgba(0,0,0,.06); }
      #rrx-cart-drawer .qv-opt--color .qv-opt-btn.is-active{ border-color: var(--ac); box-shadow: 0 0 0 3px rgba(46,125,50,.15), inset 0 0 0 1px rgba(0,0,0,.06); }
      #rrx-cart-drawer .rrx-qv-eye{
        position:absolute; right:10px; bottom:10px; inline-size: 44px; block-size: 44px;
        border-radius:999px; background:#fff; border:1px solid #e3e6ea; display:grid; place-items:center; overflow:hidden; isolation:isolate;
        box-shadow:0 6px 18px rgba(0,0,0,.10); cursor:pointer; z-index:4;
      }
      #rrx-cart-drawer .rrx-qv-eye > span{ position:relative; width:64%; height:40%; border-radius:999px / 70%; background:#111; }
      #rrx-cart-drawer .rrx-qv-eye > span::before{ content:""; position:absolute; left:50%; top:50%; width:58%; height:58%; transform:translate(-50%,-50%); border-radius:50%; background:#fff; }
      #rrx-cart-drawer .rrx-qv-eye > span::after{ content:""; position:absolute; left:50%; top:50%; width:30%; height:30%; transform:translate(-50%,-50%); border-radius:50%; background:#111; }
      @media (max-width:760px){ #rrx-cart-drawer .rrx-qv-eye{ inline-size:40px; block-size:40px; } }
      #rrx-qv-zoom{ position:fixed; inset:0; z-index:1000003; display:none; }
      #rrx-qv-zoom[aria-hidden="false"]{ display:block; }
      #rrx-qv-zoom .zoom-bd{ position:absolute; inset:0; background:rgba(0,0,0,.86); display:grid; place-items:center; }
      #rrx-qv-zoom .zoom-img{ max-width:min(92vw,1600px); max-height:86vh; width:auto; height:auto; object-fit:contain; border-radius:14px; background:#fff; }
      #rrx-qv-zoom .zoom-x{ position:absolute; right:18px; top:18px; width:40px; height:40px; background:#fff; border:1px solid #e5e5e5; border-radius:999px; display:grid; place-items:center; cursor:pointer; box-shadow:0 6px 20px rgba(0,0,0,.25); }
      #rrx-qv-zoom .zoom-x:hover{ transform:translateY(-1px) }
      #rrx-qv-zoom .zoom-x:active{ transform:scale(.98) }
      #rrx-cart-drawer .rrx-reco-wrap{ position:relative; }
      #rrx-cart-drawer .rrx-reco-nav{ display:flex; gap:8px; justify-content:flex-end; padding:6px 12px 0; }
      #rrx-cart-drawer .rrx-c-btn{ width:36px; height:36px; border-radius:999px; border:1px solid #e3e6ea; background:#fff; display:grid; place-items:center; box-shadow:0 6px 18px rgba(0,0,0,.10); }
      #rrx-cart-drawer .rrx-c-btn.is-hidden{ visibility:hidden; }
      #rrx-qv .qv-title, #rrx-qv .qv-price, #rrx-cart-drawer .qv-title, #rrx-cart-drawer .qv-price, #rrx-cart-drawer [data-product-price], #rrx-cart-drawer .price{ display:none !important; }
      .rrx-express{ margin-top:10px; }
      .rrx-express .shopify-payment-button{ width:100%; }
      .rrx-express .shopify-payment-button__button{ width:100%; border-radius:999px; min-height:48px; }
     /* === Impact-Toast Layout-Fix (Tablet) === */
@media (max-width:1024px){
  cart-notification-drawer,
  cart-notification,
  #CartNotification,
  .cart-notification{
    position: fixed !important;
    left: 12px !important;
    right: auto !important;
    bottom: 12px !important;
    transform: none !important;
    max-width: 420px !important;
    width: calc(100vw - 24px) !important;
    z-index: 1000000; /* unter deinem Drawer */
  }
}

/* Wenn dein Drawer offen ist → Toast verstecken (keine Überlappung) */
html.rrx-cart-open cart-notification-drawer,
html.rrx-cart-open cart-notification,
html.rrx-cart-open #CartNotification,
html.rrx-cart-open .cart-notification{
  display: none !important;
}
/* === Impact/Dawn Toast Layout-Fix (Tablet) === */
@media (max-width:1024px){
  cart-notification,
  #cart-notification,
  .cart-notification,
  cart-notification-drawer{
    position: fixed !important;
    left: 12px !important;
    right: auto !important;
    bottom: 12px !important;
    top: auto !important;
    transform: none !important;
    max-width: 420px !important;
    width: calc(100vw - 24px) !important;
    z-index: 1000000 !important; /* unter deinem Drawer/Overlay */
  }
}

/* Wenn dein Drawer offen ist → Toast verstecken */
html.rrx-cart-open cart-notification,
html.rrx-cart-open #cart-notification,
html.rrx-cart-open .cart-notification,
html.rrx-cart-open cart-notification-drawer{
  display: none !important;
}
 /* Remove horizontal strike on sold-out sizes (Theme + QV) */
:where(.product-form, .product-form__input, .variant-input, .product-options, .swatch)
  input[disabled] + label,
:where(.product-form, .product-form__input, .variant-input, .product-options, .swatch)
  label[aria-disabled="true"],
#rrx-cart-drawer .qv-opt--size .qv-opt-btn[disabled],
#rrx-cart-drawer .qv-opt--size .qv-opt-btn[aria-disabled="true"],
#rrx-cart-drawer .qv-opt--size .qv-opt-btn.soldout{
  text-decoration: none !important; /* <- entfernt nur die horizontale Linie */
}
#rrx-cart-drawer .qv-opt--size .qv-opt-btn.soldout::after{
  content:""; position:absolute; left:50%; top:50%;
  width:70%; height:2px; background: currentColor;
  transform:translate(-50%,-50%) rotate(-20deg); pointer-events:none;
}
/* Qty: genug Platz für 2–3-stellige Zahlen */
#rrx-cart-drawer .rrx-qty input{
  box-sizing: border-box;
  min-width: 60px;          /* vorher zu klein → jetzt 2-stellig safe */
  inline-size: max(70, 4.2ch);
  text-align: center;
  overflow: visible;        /* nichts wegclippen */
}

/* etwas Luft zwischen - [input] + */
#rrx-cart-drawer .rrx-qty{ gap: 8px; }
/* Qty-Container: genug Platz + nichts clippen */
#rrx-cart-drawer .rrx-qty{
  display: flex;            /* falls nicht schon so */
  gap: 8px;
  min-width: 120px;         /* Gesamtbreite für 2–3-stellig */
  overflow: visible;
}

/* Input: nicht schrumpfen, feste Basisbreite */
#rrx-cart-drawer .rrx-qty input{
  box-sizing: border-box;
  width: 56px !important;       /* bei Bedarf 64px */
  flex: 0 0 56px !important;    /* verhindert Flex-Schrumpfen */
  text-align: center;
}

/* Buttons fixieren (optional, stabilisiert das Layout) */
#rrx-cart-drawer .rrx-qty button{
  flex: 0 0 36px !important;
}
/* (1) Drawer immer über allem */
#rrx-cart-overlay{ z-index:1000001 !important; }
#rrx-cart-drawer { z-index:1000002 !important; }

/* (2) Sichere Viewport-Höhe + Innen-Scroll + Safe-Area */
#rrx-cart-drawer{
  max-height: 100svh;                 /* statt 100vh */
  padding-bottom: env(safe-area-inset-bottom, 12px);
  overflow: hidden;                   /* Scroll nur im Inhalt */
}
#rrx-cart-drawer .rrx-view{
  max-height: calc(100svh - 140px);   /* 140px ≈ Header/Freebar im Drawer – bei Bedarf anpassen */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* (3) Wenn der Drawer offen ist: alle „sticky“/Toast-Bars ausblenden */
html.rrx-cart-open cart-notification,
html.rrx-cart-open cart-notification-drawer,
html.rrx-cart-open #CartNotification,
html.rrx-cart-open .cart-notification,
html.rrx-cart-open [class*="announcement"],
html.rrx-cart-open [class*="cookie"],
html.rrx-cart-open [class*="sticky"],
html.rrx-cart-open [data-sticky]{
  display: none !important;
}

    `;
    document.head.appendChild(s);
  }catch(_){}
})();







































































